/*
 * Scenario: version-mismatch
 *
 * Schickt einen rewrite-Vorschlag mit absichtlich veralteter baseVersion
 * (lokale Version - 1). Der ReviewController muss bei Accept den Versions-
 * Check feuern, den Apply unterdruecken, status='version_mismatch' melden
 * und einen Console-Hinweis loggen ("Paragraph was changed concurrently —
 * proposal auto-rejected.").
 *
 * Wichtig: das passiert erst beim Accept-Versuch, nicht beim Eingang des
 * Vorschlags. Im Browser-Test bedeutet das: User sieht den Vorschlag,
 * druckt A, danach erscheint die System-Notiz im Panel.
 */

import { emit, wait } from './_helpers.js'

export const name = 'version-mismatch'
export const description = 'Rewrite with stale baseVersion → auto-rejected on accept.'

export async function run(state) {
    const toolCallId = 'tu_vm_' + Date.now().toString(36)

    await emit(state, 'session', { sessionId: 'mock-version-mismatch' }, 0)
    await emit(state, 'thinking', { text: 'Tweaking the opening line…' }, 200)
    await emit(state, 'thinkingDone', {}, 150)

    const cursor = state.context?.cursorContext
    const paragraphId = cursor?.paragraphId
    const localVersion = typeof cursor?.version === 'number' ? cursor.version : 1
    const originalText = typeof cursor?.text === 'string' ? cursor.text : ''

    await emit(state, 'proposeRewrite', {
        toolCallId,
        paragraphId,
        // Absichtlich veraltet: ReviewController findet localVersion und lehnt ab.
        baseVersion: localVersion - 1,
        originalText,
        newText: 'A different opening line, based on what I saw earlier — but the paragraph has changed since.',
        reason: 'Demonstrates the optimistic concurrency check.'
    }, 300)
    await emit(state, 'done', { usage: {} }, 200)

    try {
        const info = await wait(state, toolCallId, 5 * 60 * 1000)
        // Erwartet: result==='version_mismatch'; das Scenario reagiert
        // egal wie, aber realistisch waere ein Re-Read.
        const reaction = info.result === 'version_mismatch'
            ? 'The paragraph changed since I last looked. Let me re-read.'
            : info.result === 'applied'
                ? 'Applied — though I expected a version conflict.'
                : 'Okay, leaving it as it was.'
        await emit(state, 'delta', { text: reaction }, 250)
        await emit(state, 'done', { usage: {} }, 100)
    } catch { /* abort */ }
}
